import { render, staticRenderFns } from "./caijuewenshushangchuan.vue?vue&type=template&id=d6a45f06&scoped=true"
import script from "./caijuewenshushangchuan.vue?vue&type=script&lang=js"
export * from "./caijuewenshushangchuan.vue?vue&type=script&lang=js"
import style0 from "./caijuewenshushangchuan.vue?vue&type=style&index=0&id=d6a45f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a45f06",
  null
  
)

export default component.exports